import { ArrowRight, ArrowLeft } from '@phosphor-icons/react';
import { cva } from 'class-variance-authority';
import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

const styles = cva(
  [
    'side-panel-shell',
    'overflow-hidden',
    'h-full',
    'flex',
    'lg:relative',
    'absolute',
    'dark:border-neutral-100',
    'border-r-black',
    'border-r'
  ],
  {
    variants: {
      open: {
        true: ['w-1/3', 'min-w-420px'],
        false: 'pr-0'
      }
    }
  }
);

export function SidePanelShell(
  props: ComponentProps<'div'> & {
    open: boolean;
    setOpen: (visible: boolean) => void;
  }
) {
  const { className, children, open, setOpen, ...rest } = props;
  return (
    <div className={twMerge(styles({ open }), className)} {...rest}>
      <div className="flex flex-col h-full flex-grow-0 w-full overflow-hidden">
        {children}
      </div>
      <button
        onClick={() => props.setOpen(!open)}
        className="grid place-items-center text-secondary flex-grow"
      >
        {open ? <ArrowLeft /> : <ArrowRight />}
      </button>
    </div>
  );
}
